import { CartSettings, withCartFactory } from '@grandvisionhq/www-next/pages/cart/hoc'
import { InjectedCartProps } from '@grandvisionhq/www-next/pages/cart/hoc'

export const settings: CartSettings = {
  maximumQuantity: 5,
  isDiscountCodeEnabled: true,
  shouldShowCartDiscountOnLineItem: true,
  shouldShowSubTotal: true,
  shouldShowTotalDiscount: true,
  onFinalizedCartError: ({ resetCallback }: { resetCallback: () => void }) => {
    resetCallback()
  },
  onUnRecoverableError: ({ resetCallback }: { resetCallback: () => void }) => {
    resetCallback()
  },
}

export type { InjectedCartProps }

export const withCart = withCartFactory(settings)
